import moment from "moment";

export const formatBytes = (value) => {
  if (!value || Number.isNaN(Number(value))) return "N/A";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = Number(value);
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size.toFixed(size >= 10 || unitIndex === 0 ? 0 : 1)} ${
    units[unitIndex]
  }`;
};

export const formatDeviceValue = (key, value) => {
  if (value === null || typeof value === "undefined" || value === "") {
    return "N/A";
  }
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (
    [
      "maxMemory",
      "totalMemory",
      "usedMemory",
      "totalDiskCapacity",
      "freeDiskStorage",
    ].includes(key)
  ) {
    return formatBytes(value);
  }
  if (["firstInstallTime", "lastUpdateTime"].includes(key) && Number(value)) {
    return moment(Number(value)).format("DD MMM YYYY hh:mm A");
  }
  if (key === "batteryLevel" && typeof value === "number") {
    return `${Math.round(value * 100)}%`;
  }
  if (typeof value === "object") return JSON.stringify(value, null, 2);
  return String(value);
};
